import { toastController, loadingController } from '@ionic/vue'

const toast = async (ops) => {
  if (Object.prototype.toString.call(ops) == '[object Object]') {
    const toast = await toastController
      .create({
        message: ops.message,
        position: ops.position || 'top',
        translucent: ops.translucent || true,
        color: ops.color,
        duration: ops.duration || 3000,
      })
    return toast.present()
  } else {
    const toast = await toastController
      .create({
        message: ops,
        position: 'top',
        translucent: true,
        duration: 3000,
      })
    return toast.present()
  }
}


const loadingCreate = async (message) => {
  const loading = await loadingController.create({
    cssClass: 'my-custom-class',
    message: message,
  })
  await loading.present()
  return loading
}

export { toast, loadingCreate }